module.exports = __webpack_public_path__ + "static/MonoramaRegular-f382deb5c42d10bd5ff7054a1a120f55.woff";